import { Heading } from "@trueskin-web/components"
import { Trans } from "@trueskin-web/translations"

const TestimonialImageCard = ({ images = [], labels = [] }) =>
  images.length > 0 ? (
    <>
      <div
        sx={{
          mt: 4,
          borderRadius: "8px",
          display: "flex",
          gap: 2,
          flexWrap: "nowrap",
        }}
      >
        {images.length > 1 ? (
          images.map((image, index) => (
            <img
              key={index}
              src={image}
              alt=""
              sx={{
                objectFit: "contain",
                maxWidth: "calc(50% - 4px)",
                "&:nth-of-type(odd)": {
                  borderRadius: "8px 0 0 8px",
                },
                "&:nth-of-type(even)": {
                  borderRadius: "0 8px 8px 0",
                },
              }}
            />
          ))
        ) : (
          <img
            src={images[0]}
            alt=""
            sx={{
              width: "100%",
              maxWidth: [620, 310],
              borderRadius: "8px",
            }}
          />
        )}
      </div>
      <div
        sx={{
          mt: 2,
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        {labels.map((label, index) => (
          <div key={index} sx={{ flex: 1, textAlign: "center", fontSize: 0 }}>
            {label}
          </div>
        ))}
      </div>
    </>
  ) : null

const Testimonials = ({
  headline,
  subline,
  customer,
  images,
  labels,
  className,
}) => (
  <div
    sx={{
      mt: [5, 0],
      py: [5, 4],
      px: 4,
      textAlign: ["center", "left"],
      border: "1px",
      borderColor: "brandNeutralsMediumGrey",
      borderRadius: "8px",
      fontSize: 1,
      display: [null, "grid"],
      gridColumnGap: [null, 4],
      gridRowGap: [null, 4],
      gridTemplateRows: [null, "1fr 1fr"],
      gridTemplateColumns: [null, "1fr 310px"],
      gridTemplateAreas: [
        null,
        `
          "header photos"
          "footer photos"
        `,
      ],
    }}
    data-testid="web-portal-plan-selection-testimonials"
    className={className}
  >
    <div sx={{ gridArea: "header", alignSelf: "flex-end" }}>
      <Heading
        as="h3"
        size="sm"
        sx={{ mb: 1, fontSize: 3, fontWeight: "bold" }}
      >
        {headline}
      </Heading>
      {subline}
    </div>
    <div sx={{ gridArea: "photos" }}>
      <TestimonialImageCard images={images} labels={labels} />
    </div>
    <div sx={{ gridArea: "footer", alignSelf: "flex-start" }}>
      <div sx={{ mt: [4, 0] }}>{customer}</div>
      <div sx={{ mt: 1, color: "textDark" }}>
        <Trans i18nKey="ChoosePlan.Testimonials.reviews" />
      </div>
    </div>
  </div>
)

export default Testimonials
